import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {useNavigate} from 'react-router-dom';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import Button from 'shared/ui/Button/Button/Button';
import PaginationChevronLeftIcon from 'shared/ui/icons/PaginationChevronLeftIcon';
import {isTranslate} from 'shared/lib/lang';

import {ITariffAdvantageState} from '../../lib/tariffAdvantages';

import AdvantagesList from './AdvantagesList/AdvantagesList';

import styles from './Advantages.module.scss';

interface IAdvantagesProps {
    offered: ITariffAdvantageState[],
    included: ITariffAdvantageState[],
    price: number | null,
}

const Advantages: React.FC<IAdvantagesProps> = ({offered, included, price}) => {
    const navigate = useNavigate();
    const hasPrice = !isTranslate() && null !== price;

    if (!offered.length && !included.length) {
        return null;
    }

    return (
        <div className={styles.advantages}>
            <div className={styles.head}>
                <h2 className={styles.title}>
                    <Trans
                        id="home.plug.advantages.title"
                        message="Продвинутые возможности Overseer"
                    />
                </h2>
                {
                    hasPrice &&
                    <span className={styles.price}>
                        <Trans
                            id="home.plug.advantages.subtitle"
                            message="всего от {price}₽ в месяц!"
                            values={{price}}
                        />
                    </span>
                }
            </div>
            <p className={styles.lead}>
                <Trans
                    id="home.plug.advantages.text"
                    message="Всегда лучше предупредить, чем лечить!"
                />
                {' '}
                <Trans
                    id="home.plug.advantages.lead"
                    message="Мы не только ловим падения, но и заранее предупреждаем о сроках домена,
                        сертификатах и ошибках на странице."
                />
            </p>
            <AdvantagesList title={t`Что можно подключить`} items={offered} variant="offered"/>
            <AdvantagesList title={t`Уже в вашем тарифе`} items={included} variant="included"/>
            {
                hasPrice &&
                <div className={styles.foot}>
                    <span className={styles.footNote}>
                        {t`Подключается на любом платном тарифе, переключиться можно в любой момент`}
                    </span>
                    <Button
                        variant="gradient"
                        onClick={() => navigate(AppUrls.TARIFFS)}
                        className={styles.tariffButton}
                    >
                        {t`Посмотреть тарифы`}
                        <span className={styles.tariffChevron}><PaginationChevronLeftIcon/></span>
                    </Button>
                </div>
            }
        </div>
    );
};

export default Advantages;
